// Single product header JS placeholder.
(() => {
  const el = document.querySelector(".c-single-product__header");
  if (!el) return;
})();

